(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RecentSearches", [], factory);
	else if(typeof exports === 'object')
		exports["RecentSearches"] = factory();
	else
		root["RecentSearches"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 